// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-3740c459] .i-text {
  overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/publication/ContractProposalForm.vue","webpack://./ContractProposalForm.vue"],"names":[],"mappings":"AAGA;EACE,iBAAA;ACFF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n\n:deep(.i-text) {\n  overflow: visible;\n}\n\n",":deep(.i-text) {\n  overflow: visible;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
